(function() {
  function buildDecisionTree(texts) {
    return {
      question: texts.question1,
      options: {
        Indoor: {
          question: texts.question2,
          options: {
            Smooth: { result: { type: 'indoorSmooth' } },
            'Brushed/Broomed': { result: { type: 'indoorBrushed' } }
          }
        },
        Outdoor: {
          question: texts.question2,
          options: {
            Pavers: { result: { type: 'outdoorPavers' } },
            Stamped: { result: { type: 'outdoorStamped' } },
            Smooth: { result: { type: 'outdoorSmooth' } },
            'Brushed/Broomed': { result: { type: 'outdoorBrushed' } }
          }
        }
      }
    };
  }

  function initQuiz(sectionId) {
    var config = window.quizCtaConfigs && window.quizCtaConfigs[sectionId];
    if (!config || !config.texts) return;

    var cardsContainer = document.getElementById('quiz-cards-' + sectionId);
    var container = document.getElementById('quiz-' + sectionId);
    var ctaContent = document.getElementById('cta-content-' + sectionId);
    var triggerBtn = document.getElementById('quiz-trigger-' + sectionId);
    if (!container || !ctaContent) return;

    var decisionTree = buildDecisionTree(config.texts);
    var currentNode = null;
    var path = [];

    function btn(text, className, onClick, ariaLabel) {
      var el = document.createElement('button');
      el.textContent = text;
      el.className = className;
      if (ariaLabel) el.setAttribute('aria-label', ariaLabel);
      el.onclick = onClick;
      return el;
    }

    function closeQuiz() {
      container.style.display = 'none';
      ctaContent.style.display = 'flex';
    }

    function goBack() {
      path.pop();
      currentNode = path[path.length - 1];
      renderNode(currentNode);
    }

    function getProductCards(categories) {
      var fragment = document.createDocumentFragment();
      if (!cardsContainer) return fragment;
      categories.forEach(function(cat) {
        var div = cardsContainer.querySelector('[data-quiz="' + cat + '"]');
        if (div) {
          div.querySelectorAll('.quiz-product-item').forEach(function(card) {
            fragment.appendChild(card.cloneNode(true));
          });
        }
      });
      return fragment;
    }

    function addHeader(titleText) {
      var header = document.createElement('div');
      header.className = 'quiz-header';
      var h = document.createElement('h3');
      h.textContent = titleText;
      header.appendChild(h);
      container.appendChild(header);
    }

    function addOptions(optionKeys, onChoose) {
      var wrap = document.createElement('div');
      wrap.className = 'quiz-options';
      optionKeys.forEach(function(key) {
        wrap.appendChild(btn(key, 'quiz-btn quiz-option-btn', function() { onChoose(key); }));
      });
      container.appendChild(wrap);
    }

    function renderNode(node) {
      container.innerHTML = '';
      container.appendChild(btn('×', 'quiz-close-btn', closeQuiz, 'Close'));
      if (path.length > 1) container.appendChild(btn('← Back', 'quiz-back-btn', goBack));
      addHeader(node.question);
      addOptions(Object.keys(node.options), function(key) {
        currentNode = node.options[key];
        path.push(currentNode);
        if (currentNode.result) renderFinishStep(currentNode.result);
        else renderNode(currentNode);
      });
    }

    function renderFinishStep(result) {
      container.innerHTML = '';
      container.appendChild(btn('×', 'quiz-close-btn', closeQuiz, 'Close'));
      container.appendChild(btn('← Back', 'quiz-back-btn', goBack));
      addHeader(config.texts.question3);
      addOptions(['Satin', 'Gloss'], function(finish) {
        showResult(result, finish);
      });
    }

    function showResult(result, finish) {
      container.innerHTML = '';
      container.appendChild(btn('×', 'quiz-close-btn', closeQuiz, 'Close'));

      var location = result.type.indexOf('outdoor') === 0 ? 'outdoor' : 'indoor';
      var finishKey = location + (finish === 'Satin' ? 'Satin' : 'Gloss');
      var categories = ['common', result.type, finishKey];
      var productsFragment = getProductCards(categories);
      var resultDiv = document.createElement('div');
      resultDiv.className = 'quiz-result';

      var title = document.createElement('h3');
      title.textContent = config.texts.resultTitle;
      resultDiv.appendChild(title);

      if (productsFragment.childNodes.length > 0) {
        var grid = document.createElement('div');
        grid.className = 'quiz-products-grid';
        grid.appendChild(productsFragment);
        resultDiv.appendChild(grid);
      } else {
        var p = document.createElement('p');
        p.className = 'quiz-no-products';
        p.textContent = 'No products available for this selection.';
        resultDiv.appendChild(p);
      }

      resultDiv.appendChild(btn(config.texts.restartButton, 'quiz-btn quiz-btn-primary', function() {
        path = [decisionTree];
        currentNode = decisionTree;
        renderNode(decisionTree);
      }));
      container.appendChild(resultDiv);
    }

    function openQuiz() {
      container.style.display = 'block';
      ctaContent.style.display = 'none';
      path = [decisionTree];
      currentNode = decisionTree;
      renderNode(decisionTree);
    }

    if (triggerBtn) triggerBtn.addEventListener('click', function(e) { e.preventDefault(); openQuiz(); });
  }

  function run() {
    window.quizCtaConfigs = window.quizCtaConfigs || {};
    document.querySelectorAll('.quiz-container[data-quiz-section-id]').forEach(function(el) {
      var id = el.getAttribute('data-quiz-section-id');
      if (id && window.quizCtaConfigs[id]) initQuiz(id);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
